module.exports = __webpack_public_path__ + "Lato-Regular.8ed525743dbb32ae4bdb.woff";


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/assets/fonts/Lato/Lato-Regular.woff
// module id = ../../../../../src/assets/fonts/Lato/Lato-Regular.woff
// module chunks = styles